import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const notificationsPlugin = createPlugin({
  id: 'notifications',
  routes: {
    root: rootRouteRef,
  },
});

// export const NotificationsPage = notificationsPlugin.provide(
//   createRoutableExtension({
//     name: 'NotificationsPage',
//     component: () =>
//       import('./NotificationsClient').then(m => m.NotificationsProvider),
//     mountPoint: rootRouteRef,
//   }),
// );
export const NotificationsSystem = notificationsPlugin.provide(
  createComponentExtension({
    name: 'NotificationsSystem',
    component: {
      lazy: () =>
        import('./NotificationsClient').then(m => m.NotificationsProvider),
    },
  }),
);
